var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#10338C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 32.9941L95.3 170.994L513 310.754V341.324L0 170.994L513 -0.00585938V32.9941Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 287.174V311.754L81.72 170.994L513 29.9941V54.1541",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.98 140.204L455.09 150.884L451.91 135.564L483.1 105.794C483.1 105.794 473.68 65.144 469.35 60.814L357.03 116.634L350.19 153.394L318.29 181.984L317.89 216.184L352.18 193.424L419.41 190.764L417.9 228.874H440.13L452.03 184.234L483.58 159.624L476.98 140.204Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.89 238.404L295.65 227.294L317.89 216.184H462.35V238.404H317.89Z",
    fill: "#EFC100"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.772 215.684H462.85V238.904H317.772L294.531 227.294L317.772 215.684ZM318.008 216.684L296.769 227.294L318.008 237.904H461.85V216.684H318.008Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAs);
export default __webpack_public_path__ + "static/media/AS.9f64e17262edbb93dc9539cbadec9586.svg";
export { ForwardRef as ReactComponent };